<template>
  <div class="images">
    <Dropzone
      v-model="value"
      :aspect="aspect"
      :label="label"
      :icon="icon"
      @click="emit('chooseFile')"
    />
    <div class="image-list" role="list">
      <box
        v-for="file in value"
        :key="file.id"
        :aspect="1"
        role="listitem"
      >
        <inline-file :file="file" @remove="removeFile(file)" />
      </box>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import type { FileUpload } from '@utils/upload/fileUpload';
import { useDeletePrompt } from '@utils/prompt/injects';
import InlineFile from '@utils/upload/InlineFile.vue';
import type { Component } from 'vue';
import type { WbFile } from '@/entities/Entities';
import Dropzone from './Dropzone.vue';
import Box from '../Box.vue';

interface Props {
  acceptedFiles?: string;
  useHeight?: boolean;
  label?: string;
  icon?: Component;
  modelValue?: FileUpload<WbFile>[];
  withButton?: boolean;
  aspect?: number;
}

const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue', 'chooseFile']);
const value = useVModel(props, 'modelValue', emit, { passive: true });
const deletePrompt = useDeletePrompt();

const removeFile = async (fileToDelete: FileUpload<WbFile>) => {
  if (await deletePrompt?.()) {
    value.value = value.value?.filter((file) => file.id !== fileToDelete.id);
  }
};
</script>

<style lang="scss" scoped>
.image-list {
  @apply mt-6;
  @apply grid grid-cols-4 gap-5;
}
</style>
